export default "__VITE_PUBLIC_ASSET__88236e1a__"